import { IconName } from 'components/atomic/atoms/icon/components/custom-icons'
import { ResourceTypes as ResTypes } from 'types/types'

export const ResourceTypes = {
    INFORMATIONAL: 'INFORMATIONAL',
    QUIZ: 'QUIZ',
    VIDEO: 'VIDEO',
    PROJECT: 'PROJECT',
    ARTICLE: 'ARTICLE',
    LESSON: 'LESSON',
    KANBAN_PROJECT: 'KANBAN_PROJECT',
    EXTERNAL_RESOURCE: 'EXTERNAL_RESOURCE',
} as { [key: string]: ResTypes }

export const pluralizeForURL = (value: ResTypes): string => {
    switch (value.toUpperCase()) {
        case 'EXTERNAL_RESOURCE':
            return 'external-resources'
        case 'INFORMATIONAL':
            return 'informationals'
        case 'ARTICLE':
            return 'articles'
        case 'VIDEO':
            return 'videos'
        case 'KANBAN_PROJECT':
            return 'kanban-projects'
        case 'LESSON':
            return 'lessons'
        case 'PROJECT':
            return 'projects'
        case 'QUIZ':
            return 'quizzes'
        default:
            throw new Error('Invalid resource type')
    }
}

export const mapIcon = (value: ResTypes): IconName => {
    switch (value.toUpperCase()) {
        case 'EXTERNAL_RESOURCE':
            return 'link'
        case 'INFORMATIONAL':
            return 'infoOutlined'
        case 'ARTICLE':
            return 'descriptionOutlined'
        case 'VIDEO':
            return 'videoOutlined'
        case 'KANBAN_PROJECT':
            return 'ballot'
        case 'LESSON':
            return 'library'
        case 'PROJECT':
            return 'handyman'
        case 'QUIZ':
            return 'helpOutline'
        default:
            return 'link'
    }
}
